@for (label of labels(); track label) {
  <div class="d-flex align-items-center mb-2">
    <div class="green-check vertical-center mr-2">
      <i class="fas fa-check text-center fw-normal" aria-hidden="true"></i>
    </div>
    <span [innerHTML]="label | translate: translateParams | safeHtml" data-test="green-check-list-item"></span>
  </div>
}
